import isNumber from './is-number';

const isPositive = function(num: any): boolean {
  return isNumber(num) && num > 0;
};

export default isPositive;
